<template>
  <div>
    <Title :title="'收入数据趋势'" class="margin-top" :isActiveSec="true"></Title>
    <Chart :cdata="cdata" :height="style.height" :width="style.width" />
  </div>
</template>

<script>
import BigTitle from '../../bigTitle';
import Chart from '../chart.vue'
import Title from '../../title.vue'
import { batteryHolderLeft } from '@/api/batteryHolder/left';
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      style:{
        width: '500',
        height: '180'
      },
      cdata: {
        category: [],
        rateData: [],
        id:"carAddChart",
        legendData:[],
        series:[
            {
              name: "",
              type: "line",
              symbolSize: 1,
              smooth: true,
              areaStyle: {
                color:new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color:"#1968FF" },
                    { offset: 1, color: "#36A1FF "}
                ]),
                opacity: 0.5
              },
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: "#1968FF" },
                    { offset: 0, color: "#3DE6FF" }
                ])
              },
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
        ],
        yAxisname:""
      }
    };
  },
  components: {
    BigTitle,
    Chart,
    Title
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.selectBatteryRcvCurrent(data)
    },
    selectBatteryRcvCurrent(data={}){
      let _this = this;
      let params = {
				"enCode":"TiDB-congdiancang-shourushujuqushi",//全国
        "@battery_id":data.batteryId
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          let oper_income = [];
          let xList = [];
          res.forEach(item=>{
            oper_income.push(item.oper_income);
            xList.push(item.cur_date);
          })
          this.cdata.series[0].data = oper_income;//商用
          this.cdata.category = xList;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    
    
  }
};
</script>

<style lang="scss" scoped>
</style>